export function Healthz() {
  return <pre>{JSON.stringify({ status: 'ok', surface: 'web' }, null, 2)}</pre>;
}
